import React from 'react'
import { CloseButtonProps } from './CloseButton.types'
import styles from './CloseButton.module.scss'
// import cl from 'classnames'
import { Button } from '../Button'
import { IconDelete } from 'assets'

const CloseButtonComponent = (props: CloseButtonProps) => {
  return (
    <Button
      preset='icon'
      {...props}
    >
      <IconDelete
        width={12}
        height={12}
        fill={styles.secondaryContent}
      />
    </Button>
  )
}

const CloseButton = CloseButtonComponent
export { CloseButton }
